import { render, staticRenderFns } from "./CommonFormItems.vue?vue&type=template&id=39d63eea&scoped=true&"
import script from "./CommonFormItems.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CommonFormItems.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CommonFormItems.vue?vue&type=style&index=0&id=39d63eea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d63eea",
  null
  
)

export default component.exports